import { render, staticRenderFns } from "./ProgramView.vue?vue&type=template&id=72bc403e&scoped=true"
import script from "./ProgramView.vue?vue&type=script&lang=js"
export * from "./ProgramView.vue?vue&type=script&lang=js"
import style0 from "./ProgramView.vue?vue&type=style&index=0&id=72bc403e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc403e",
  null
  
)

export default component.exports